import React from 'react';
import { Brain, Calendar, CheckSquare, Clock, Target, TrendingUp } from 'lucide-react';

const ToolsPage = () => {
  const tools = [
    {
      icon: <Calendar className="w-12 h-12 text-teal-600" />,
      title: "ADHD Planner",
      description: "Digital planner designed for ADHD brains with reminders and prioritization.",
      status: "Available"
    },
    {
      icon: <CheckSquare className="w-12 h-12 text-teal-600" />,
      title: "Task Manager",
      description: "Break down overwhelming tasks into manageable steps.",
      status: "Available"
    },
    {
      icon: <Clock className="w-12 h-12 text-teal-600" />,
      title: "Focus Timer",
      description: "Pomodoro-style timer with ADHD-friendly intervals and breaks.",
      status: "Available"
    },
    {
      icon: <Target className="w-12 h-12 text-teal-600" />,
      title: "Goal Tracker",
      description: "Set and track goals with visual progress indicators.",
      status: "Available"
    },
    {
      icon: <Brain className="w-12 h-12 text-teal-600" />,
      title: "Mindfulness Exercises",
      description: "Quick meditation and grounding techniques for ADHD minds.",
      status: "Available"
    },
    {
      icon: <TrendingUp className="w-12 h-12 text-teal-600" />,
      title: "Mood Tracker",
      description: "Track mood patterns and identify triggers over time.",
      status: "Coming Soon"
    }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">ADHD Tools</h1>
          <p className="text-xl opacity-90">Practical tools designed for your ADHD brain</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {tools.map((tool, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md p-8 text-center hover:shadow-xl transition">
                <div className="mb-4 flex justify-center">{tool.icon}</div>
                <h3 className="text-xl font-bold mb-3">{tool.title}</h3>
                <p className="text-gray-600 mb-4">{tool.description}</p>
                <span className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${
                  tool.status === 'Available' 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {tool.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ToolsPage;